module.exports = __webpack_public_path__ + "static/media/webhooks.ad927683.png";